<template>
  <div>正在跳转到home页面。。。</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data(){
    return{
    
    }
  },
  mounted(){
    this.init()
 }, 
  methods:{
  async init(){
      var url = window.location.href;
         //access_token是后台所指定的key
     let code = url.split('?')[1]; 
      let redirectUrl='redirectUrl=http://127.0.0.1:8080/chuancheng-test/login'
      // let redirectUrl = 'redirectUrl=https://www.yiankb.com/chuancheng-test/login'
     console.log('!!!!!',code)
      let res  = await this.$http.get(`/callback?${redirectUrl}&${code}`)
       if(res&&res.data.code==0){
            var token = res.data.access_token
            var refresh_token = res.data.refresh_token
            var token_type = res.data.token_type
            var expir = res.data.expires_in * 1000 / 2 + new Date().getTime();
            console.log(8989898,expir)
            window.localStorage.setItem("token", token);
            window.localStorage.setItem("token_type", token_type);
            window.localStorage.setItem("refresh_token", refresh_token);
            window.localStorage.setItem("expir", expir);
            window.open('./home','_self')
       }else{
            this.$message.error(res.data.msg||'请求失败～')
       }

}
  }
}
</script>

<style>

</style>